import { componentStyle } from '@/styling/util/component-style.ts';

export const progressSpinnerStyle = componentStyle({
    colorOne: '{primary.color}',
    colorTwo: '{primary.color}',
    colorThree: '{primary.color}',
    colorFour: '{primary.color}',
});
